export enum TriggerTypes {
    newViolationFound = "newViolationFound",
    newResourceFound = "newResourceFound",
}
